<template>
  <div class="video-url" @click="irParaVideo">
    <div class="card-image">
      <a class="btn-fav" :class="{ active: isFavorited }" @click="toggleFavorite" title="Adicionar aos favoritos">
        <i :class="isFavorited ? 'fa-solid fa-heart' : 'fa-regular fa-heart'"></i>
      </a>
      <a class="btn-cart" @click="addToCart" title="Adicionar ao carrinho">
        <i class="fa fa-cart-plus icon"></i>
      </a>
      <img class="img-default" src="../assets/background/capa-padrao-video.png" />
      <img class="img-hover" src="../assets/background/capa-hover-video.png" />
      <div class="hover-overlay">
        <p class="price-discipline">R$ {{ displayPrice }}</p>
      </div>
    </div>

    <div class="video-info">
      <span class="title-video">{{ video.nome_disciplina }} - Video {{ video.ordem_aula }}</span>
    </div>
    <div class="hover-purple"></div>
  </div>
</template>

<style scoped src="../styles/CardVideo.css" />

<script>
import { getPriceByType, formatPrice } from '@/utils/pricing';

export default {
  name: 'CardVideo',
  props: {
    video: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isFavorited: false,
    };
  },
  computed: {
    displayPrice() {
      return formatPrice(getPriceByType('video-aula'));
    }
  },
  methods: {
    toggleFavorite(event) {
      event.stopPropagation();
      this.isFavorited = !this.isFavorited;
    },
    addToCart(event) {
      event.stopPropagation();
      const item = {
          codigo_disciplina: this.video.codigo_aula,
          nome_disciplina: `${this.video.nome_disciplina} - Video ${this.video.ordem_aula}`,
          url_imagem: null,
          preco: getPriceByType('video-aula'),
          tipo: 'video-aula'
      };
      this.$emit("add-to-cart", item);
    },
    irParaVideo() {
      console.log('Enviando codigo_aula:', this.video.codigo_aula);

      this.$router.push({
        path: '/video',
        query: {
          codigo_aula: this.video.codigo_aula
        }
      });
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }

};
</script>
